import { isValidQuery } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const GoogleAiModeContent: SDEContent = {
  projectType: 'async_google_ai_mode',
  projectCategory: 'google',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/google/aimode/v1`;
  },
  docsSection: '',
  docsSectionTitle: '',
  docsSectionAsync: '',
  docsSectionAsyncTitle: '',
  inputKey: 'query',
  inputsKey: 'queries',
  validatorFunction: isValidQuery,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'Search terms',
      listLiteralInputPlaceholder: 'Enter one search term per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: 'Input search terms',
      inputSectionDescription: "Enter the search terms you want Google AI Mode to answer.",
    },
    projectContent: {
      title: 'Google AI Mode',
      description: 'Get Google AI Mode answers for search terms as structured data with sources.',
      icon: 'google',
      inputTitle: 'Query',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input search terms',
      inputSectionDescription: 'Enter the search terms you want Google AI Mode to answer.',
    },
    projectContent: {
      title: 'Google AI Mode',
      description: 'Get Google AI Mode answers for search terms as structured data with sources.',
      icon: 'google',
    },
    enterInputsPlaceholder: 'Enter a search term for Google AI Mode',
    enterInputsMessage: 'Enter a search term for Google AI Mode',
    codeViewPlaceHolder: 'Please provide a valid search term',
    dropdownTitle: 'Google AI Mode'
  }
};
